import anime from 'animejs'
import { onSelect } from '../utils/dom'

const PATHS = {}

if (onSelect('#_soyh5qm8e')) {
  PATHS.PATH_MEET_1 = anime.path(`#_soyh5qm8e svg.template-belt .path-meeting-1`)
  PATHS.PATH_WEDD_1 = anime.path(`#_soyh5qm8e svg.template-belt .path-wedding-1`)
  PATHS.PATH_CAKE_1 = anime.path(`#_soyh5qm8e svg.template-belt .path-cake-1`)
  PATHS.PATH_MEET_2 = anime.path(`#_soyh5qm8e svg.template-belt .path-meeting-2`)
  PATHS.PATH_WEDD_2 = anime.path(`#_soyh5qm8e svg.template-belt .path-wedding-2`)
  PATHS.PATH_CAKE_2 = anime.path(`#_soyh5qm8e svg.template-belt .path-cake-2`)
  PATHS.PATH_MEET_3 = anime.path(`#_soyh5qm8e svg.template-belt .path-meeting-3`)
  PATHS.PATH_WEDD_3 = anime.path(`#_soyh5qm8e svg.template-belt .path-wedding-3`)
  PATHS.PATH_CAKE_3 = anime.path(`#_soyh5qm8e svg.template-belt .path-cake-3`)
}

export default PATHS
